import request from '@/utils/request'

export function putQuestionnaire(data) {
    return request({
        url: 'common/addPersonnel',
        method: 'post',
        data
    })
}